import React from 'react';
import PropTypes from 'prop-types';
import { chunk } from '../../../utils/helper-functions';
import Img from 'gatsby-image';
import ProjectBlurb from '../project-blurb';
import { css } from 'emotion';
import styles from './project-ad-stills.module.css';
import { Trail } from 'react-spring';
import Reveal from '../../reveal';
import * as easings from 'd3-ease';

const AdStillsContent = props => {
  const { stills, blurb, wrapperPadding, isInView } = props;

  const renderRows = () => {
    const newStills = chunk(stills, 4);

    return newStills.map((stills, index) => {
      return (
        <div className={styles.row} key={index}>
          {renderAnimation(newStills[index])}
        </div>
      );
    });
  };

  const renderAnimation = stills => {
    const animationConfig = {
      delay: 300,
      duration: 800,
      easing: easings.easeCubic,
    };
    return (
      <Trail
        items={stills}
        keys={still => still.image.localFile.childImageSharp.sizes.originalImg}
        from={{ opacity: 0 }}
        to={{
          opacity: isInView ? 1 : 0,
        }}
        config={animationConfig}
      >
        {still => props => {
          return (
            <div className={styles.still}>
              <Img
                style={props}
                sizes={still.image.localFile.childImageSharp.sizes}
                backgroundColor={true}
              />
            </div>
          );
        }}
      </Trail>
    );
  };

  return (
    <React.Fragment>
      <div
        className={[
          styles.wrapper,
          css`
            padding: ${wrapperPadding};
          `,
        ].join(' ')}
      >
        <div className={styles.stillsWrapper}>{renderRows()}</div>
        {typeof blurb !== 'undefined' && <ProjectBlurb blurb={blurb} />}
      </div>
    </React.Fragment>
  );
};

const ProjectAdStills = props => {
  return (
    <Reveal>
      <AdStillsContent {...props} />
    </Reveal>
  );
};

AdStillsContent.propTypes = {
  stills: PropTypes.array,
  blurb: PropTypes.string,
  wrapperPadding: PropTypes.string,
  isInView: PropTypes.bool,
};

export default ProjectAdStills;



// WEBPACK FOOTER //
// ./src/components/project/project-ad-stills/index.js